var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{staticClass:"main-administrationColumnsDevices"},[_c('Navbar'),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"margin-vertical"},[_c('AdministrationColumnsDevicesTable')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }